import React, { useState, useEffect, useRef } from 'react';
import './JobpostingDetailsNotes.css';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CkEditor from '../../../../components/CkEditor/CkEditor';
import { getUserDetails } from '../../../../_utilities/getUserInfo';
import { AddNotesillus } from '../../../../Icons/AddNotesillus';
import { updateSnackbar } from '../../../../_redux/SnackbarSlice';
import * as _ser from '../../../../_redux/_services/JobPostingSlice';
import { MenuItem, Select, Button, Stack } from '@mui/material';
import RightSideBar from '../../../../components/Rightsidebar/RightSideBar';

const initalState = { data: null, message: '', isloader: true };

const AddJobpostingDetailsNotes = ({
  onReceivePropsHandler,
  noteState,
  selectedNote,
  jobId,
}) => {
  return (
    <RightSideBar
      componentData={
        <ComponentRenderData
          noteState={noteState}
          selectedNote={selectedNote}
          onReceivechildProps={onReceivePropsHandler}
          jobId={jobId}
        />
      }
      componentLayout={
        noteState === 'Create' ? pannelAddNotesobj : pannelEditNotesobj
      }
      footerImg={noteState === 'Create' ? <AddNotesillus /> : <AddNotesillus />}
      onReceiveProps={onReceivePropsHandler}
    />
  );
};

const ComponentRenderData = (props) => {
  const dispatch = useDispatch();
  const [noteType, setnoteType] = useState('Call');
  const [textValue, setTextValue] = useState(' ');
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(false);
  const [showEditor, setShowEditor] = useState(false);

  const code = useSelector((state) => state.AddNotes.data);
  const updateCode = useSelector((state) => state.EditNotes.data);

  useEffect(() => {
    if (props.selectedNote !== null && props.noteState !== 'Create') {
      setnoteType(props.selectedNote.noteType);
      setTextValue(props.selectedNote.notes);
      setShowEditor(true);
    } else {
      setnoteType('Call');
      setTextValue(' ');
      setShowEditor(true);
    }
  }, [props.noteState]);

  useEffect(() => {
    console.log('textValue +++', textValue);
  }, [textValue]);

  const HandleSubmit = async (event) => {
    event.preventDefault();
    if (textValue.trim().length > 0 && textValue !== ' ') {
      setDisableSubmitBtn(true);
      const userInfo = await getUserDetails();
      let obj = {
        notes: textValue,
        noteType: noteType,
        moduleType: 'jobopening',
        moduleId:  props.jobId,
        userId: userInfo.userId,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      };
      if (props.noteState === 'Create') {
        dispatch(_ser.addNotesAsync(obj))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      } else {
        obj['id'] = props.selectedNote.id;
        dispatch(_ser.editNotesAsync(obj))
          .then(() => {
            setDisableSubmitBtn(false);
          })
          .catch(() => {
            setDisableSubmitBtn(false);
          });
      }
    } else {
      dispatch(updateSnackbar({ type: 'error', message: 'Please add notes' }));
    }
  };

  useEffect(() => {
    if (code === 200) {
      setTextValue('');
      handleReset();
      dispatch(_ser.addNotesStartReducer(initalState));
      props.onReceivechildProps(false, true);
    }
  }, [code]);

  useEffect(() => {
    if (updateCode === 200) {
      setTextValue('');
      handleReset();
      dispatch(_ser.editNotesStartReducer(initalState));
      props.onReceivechildProps(false, true);
    }
  }, [updateCode]);

  const handleChange = (value, type) => {
    setTextValue(value.data);
  };

  const handleChange1 = (event) => {
    setnoteType(event.target.value);
  };

  const formRef = useRef(null);

  const handleReset = () => {
    formRef.current.reset();
    setnoteType('Call');
    setTextValue('');
    props.onReceivechildProps(false, false);
  };

  return (
    <>
      <form ref={formRef}>
        <div className="type">
          Note Type
          <Select
            className="typeselectbutton"
            value={noteType}
            autoComplete="off"
            onChange={handleChange1}
          >
            <MenuItem value={'Call'}>Call</MenuItem>
            <MenuItem value={'E-mail'}>E-mail</MenuItem>
          </Select>
        </div>

        <div>
          <div id="jobDescForSMnew">
            {showEditor === true && (
              <CkEditor
                data={textValue}
                initRawData={textValue}
                autoComplete="off"
                name="note"
                isReadonly={false}
                onUpdatehandler={(update) => handleChange(update, 'note')}
              />
            )}
          </div>
        </div>

        <div className="cancelsavebutton" style={{ marginTop: '28px' }}>
          <Stack spacing={2} direction="row">
            <Button
              className="notecancelbtn"
              variant="text"
              sx={{ color: '#FF0000' }}
              type="reset"
              onClick={handleReset}
            >
              <Link href="#" underline="always">
                {' '}
                Cancel
              </Link>
            </Button>
            <Button
              className="savebtn"
              variant="contained"
              size="small"
              type="submit"
              // disabled={textValue.trim().length === 0 || disableSubmitBtn}
              onClick={HandleSubmit}
              style={{ marginLeft: '0px' }}
            >
              {props.noteState === 'Create' ? 'Save' : 'Update'}
            </Button>
          </Stack>
        </div>
      </form>
    </>
  );
};
export default AddJobpostingDetailsNotes;

const pannelAddNotesobj = {
  title: 'Add Notes',
  description: '',
  bgImage: '',
};

const pannelEditNotesobj = {
  title: 'Edit Notes',
  description: '',
  bgImage: '',
};
